import { DbFocusOptions } from '~src/types/db';
import { TableEntry } from '../FileTables/FileTable.utils';

export const focusOptions: DbFocusOptions[] = [
  {
    value: 1,
    name: 'Yellow',
    color_hex_code: 'FFF9D0',
    color_hex_code_opacity: 'f0ebc8',
  },
  {
    value: 2,
    name: 'Red',
    color_hex_code: 'FFDFE2',
    color_hex_code_opacity: 'f0d5d7',
  },
  {
    value: 3,
    name: 'Green',
    color_hex_code: 'EAF9F5',
    color_hex_code_opacity: 'deebe7',
  },
  {
    value: 4,
    name: 'Blue',
    color_hex_code: 'CCE1FD',
    color_hex_code_opacity: 'c5d6ee',
  },
  {
    value: 5,
    name: 'Grey',
    color_hex_code: 'E3E1E1',
    color_hex_code_opacity: 'd8d6d6',
  },
];
